/*
 *
 * Furniture reducer
 *
 */

import { ActionType } from 'typesafe-actions';
import * as actions from '../actions/colors';
import { ColorsState } from './../types';
import ActionTypes from 'containers/Configurator/constants/colors';

type ColorsActions = ActionType<typeof actions>;

export const initialState: ColorsState = {
  data: null,
  loading: false,
};

function reducer(
  state: ColorsState = initialState,
  action: ColorsActions,
): ColorsState {
  switch (action.type) {
    case ActionTypes.COLORS_REQUEST:
      return { ...state, loading: true };
    case ActionTypes.COLORS_SUCCESS:
      return {
        data: action.payload.colors,
        loading: false,
      };
    case ActionTypes.COLORS_FAILURE:
      console.log('COLORS_FAILURE', action.payload);
      return { ...state, loading: false };
    default:
      return state;
  }
}

export default reducer;
